import axios from 'axios';

import { ERROR_GENERAL } from '../../../../shared/constants';
import { headersWithCSRF } from '../../../../shared/utils/csrf';
import { apiClient, CLIENT_SIGNUP, CLIENTS } from '../../../shared/api';
import { DEFAULT_PER_PAGE } from '../../../shared/constants';

const FILTER_PARAMS = [{ filterType: 'tags', urlParam: 'with_tags' }];
const INCLUDE_PARAMS = 'tags';

const buildFilterParams = ({ activeFilters, searchQuery }) => {
  const filter = {};

  if (searchQuery) {
    filter.full_name = searchQuery;
  }

  FILTER_PARAMS.forEach(({ filterType, urlParam }) => {
    if (activeFilters[filterType].length > 0) {
      filter[urlParam] = activeFilters[filterType].join(',');
    }
  });

  return Object.keys(filter).length > 0 ? { filter } : {};
};

export const createClient = async (clientData) => {
  const { email, firstName, lastName } = clientData;

  const requestBody = {
    client: {
      email,
      first_name: firstName,
      last_name: lastName,
      website_id: 1, // TODO: Change website_id.
    },
  };

  try {
    const response = await axios.post(CLIENT_SIGNUP, requestBody, {
      headers: headersWithCSRF,
    });

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || ERROR_GENERAL);
  }
};

export const fetchClients = async ({
  activeFilters,
  clientName,
  page = 1,
  perPage = DEFAULT_PER_PAGE,
}) => {
  const params = {
    include: INCLUDE_PARAMS,
    ...buildFilterParams({ activeFilters, searchQuery: clientName }),
    page: {
      number: page,
      size: perPage,
    },
  };

  const response = await apiClient.get(CLIENTS, {
    includeWebsite: true,
    params,
  });

  return response.data;
};
